// extracted by mini-css-extract-plugin
module.exports = {"container":"nav_document_analyzer-module__container--r2jAB"};